<script lang="ts">
  import Separator from "$components/+blocks/Separator/Separator.svelte";
  import LoadingAtom from "$components/+blocks/Loading/LoadingAtom.svelte";
  import SidePanelInnerLayout from "$components/+layout/SidePanel/SidePanelInnerLayout.svelte";
  import IconButton from "$components/+blocks/IconButton/IconButton.svelte";
  import { sidePanel, hasDefault } from "$stores/sidePanel";
  import { Left, Cross } from "$components/+blocks/OVIcon";
</script>

<SidePanelInnerLayout>
  <IconButton
    slot="actionButton"
    variant="tertiary"
    icon={$hasDefault ? Left : Cross}
    a11yLabel="Close member profile"
    on:click={sidePanel.clearPanel}
  />
  <span
    slot="title"
    class="col-start-2 col-end-3 mx-auto text-sm font-medium text-gray-500 dark:text-gray-100"
    >Member
  </span>
  <svelte:fragment slot="content">
    <div class="mt-4 flex w-full flex-col items-center px-4 text-center font-medium">
      <LoadingAtom size="h-[58px] aspect-square mb-4" radius="rounded-lg" />
      <LoadingAtom size="h-4 w-[70px]" additionalClassNames="mt-4" />

      <Separator class="mt-4 w-full" />
      <div class="mt-4 flex w-full items-center gap-4 text-left text-xs">
        <div class="flex flex-col gap-2">
          <span class="text-gray-500/90 dark:text-gray-400">Threads</span>
          <LoadingAtom size="h-4 w-[32px]" />
        </div>
        <div class="flex flex-col gap-2">
          <span class="text-gray-500/90 dark:text-gray-400">Replies</span>
          <LoadingAtom size="h-4 w-[26px]" />
        </div>
        <div class="ml-auto flex flex-col gap-2">
          <LoadingAtom size="h-4px" />
          <LoadingAtom size="h-4px" />
        </div>
        <div class="ml-auto flex flex-col gap-2">
          <span class="text-gray-500/90 dark:text-gray-400">Member since</span>
          <LoadingAtom size="h-4 w-[64px]" />
        </div>
      </div>

      <div class="mr-auto mt-4 flex flex-col gap-2 text-left">
        <span class="text-xs text-gray-500/90 dark:text-gray-400">Roles</span>
        <div class="inline-flex flex-wrap gap-2">
          <LoadingAtom size="h-[18px] w-[48px]" radius="rounded" />
          <LoadingAtom size="h-[18px] w-[90px]" radius="rounded" />
        </div>
      </div>
    </div>
  </svelte:fragment>
</SidePanelInnerLayout>
